import { useQuery, useQueryClient } from 'react-query';
import { APP_VERSION } from '@/config/constants';
import { flushCacheAndHardReload } from 'utils/app/localStorage';

const checkVersion = () => {
    return fetch('/version/', {
        cache: 'no-store',
    })
        .then((response) => {
            if (response.status == 200) {
                return response.json();
            }
            throw new Error('Unable to get server app version');
        })
        .then((latest) => {
            if (latest.version != APP_VERSION) {
                console.log('Version mismatch. Reloading');
                return flushCacheAndHardReload();
            }
            return latest.version;
        });
};

const queryKey = 'app-version';
const queryOptions = { cacheTime: Infinity, staleTime: Infinity };

export const useAppVersion = () =>
    useQuery(queryKey, checkVersion, queryOptions);

export const usePrefetchAppVersion = () => {
    const queryClient = useQueryClient();
    queryClient.prefetchQuery(queryKey, checkVersion, queryOptions);
};
